
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAlertList as ObcAlertListElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/alert-list/alert-list.js';
 
 
 

 
 export const ObcAlertList = createComponent({
   react: React,
   tagName: 'obc-alert-list',
   elementClass: ObcAlertListElement,
   events: {
     
   }
  });
 
 